import { Component, OnInit } from '@angular/core';
import { ApiService, SearchQuery } from '../_services/api.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchText= "";
  queries: SearchQuery[];

  constructor(private api: ApiService) { }

  ngOnInit() {

  }

  searchEvent(event: string) {
    console.log(event);
    if(event.length > 2)
      this.getSearch(event)


  }

  getSearch(msg: string) {
    this.api.search(msg).subscribe(values => {
      this.queries = values
    })
  }

  submit(){
    console.log(this.searchText)
    this.searchText="";
  }

}
